import { Store } from '@betgames/bg-state-manager';
import { formatToCurrency } from 'utils/formatToCurrency';
import SessionStore from 'store/Session/Session.store';
import { IBalanceState } from './interfaces';
import BalanceRepository from './Balance.repository';

export default class BalanceStore extends Store<IBalanceState> {
    private setError = (): void => {
        this.update((draft) => {
            draft.unavailable = true;
        });
    };

    constructor(
        private readonly repository: BalanceRepository,
        private readonly sessionStore: SessionStore,
    ) {
        super({
            key: 'Balance',
            default: {
                amount: null,
                formattedAmount: null,
                unavailable: false,
            },
        });
    }

    setAmount = (amount: string): void => {
        this.update((draft) => {
            draft.unavailable = false;
            draft.amount = amount;
            draft.formattedAmount = formatToCurrency(
                Number(amount),
                this.sessionStore.currencyPrecision,
                this.sessionStore.currencyTemplate,
            );
        });
    };

    public fetchBalance = (): Promise<void> =>
        this.repository.fetch().then(this.setAmount).catch(this.setError);
}
